var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 25,
    viewBox: "0 0 27 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_150_775)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.5843 0.000488281H5.41764C3.98158 0.00222049 2.60483 0.57745 1.58938 1.6C0.573932 2.62255 0.00269674 4.00893 0.000976563 5.45503L0.000976562 18.5459C0.00269674 19.992 0.573932 21.3784 1.58938 22.401C2.60483 23.4235 3.98158 23.9988 5.41764 24.0005H20.5843C22.0204 23.9988 23.3971 23.4235 24.4126 22.401C25.428 21.3784 25.9993 19.992 26.001 18.5459V5.45503C25.9993 4.00893 25.428 2.62255 24.4126 1.6C23.3971 0.57745 22.0204 0.00222049 20.5843 0.000488281ZM5.41764 2.18231H20.5843C21.233 2.18359 21.8665 2.38032 22.4032 2.74718C22.9399 3.11404 23.3553 3.63425 23.596 4.24085L15.2998 12.5961C14.6893 13.2085 13.8627 13.5523 13.001 13.5523C12.1393 13.5523 11.3127 13.2085 10.7021 12.5961L2.40598 4.24085C2.64664 3.63425 3.06206 3.11404 3.59878 2.74718C4.1355 2.38032 4.76896 2.18359 5.41764 2.18231ZM20.5843 21.8187H5.41764C4.55569 21.8187 3.72904 21.4739 3.11955 20.8601C2.51005 20.2464 2.16764 19.4139 2.16764 18.5459V7.0914L9.17031 14.1387C10.1872 15.16 11.5648 15.7336 13.001 15.7336C14.4372 15.7336 15.8148 15.16 16.8316 14.1387L23.8343 7.0914V18.5459C23.8343 19.4139 23.4919 20.2464 22.8824 20.8601C22.2729 21.4739 21.4463 21.8187 20.5843 21.8187Z",
    fill: "#B82428"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_150_775"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0417,
    height: 25,
    fill: "white",
    transform: "translate(0 0.000488281)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.12f192aedfac667b9923c353d1512b9d.svg";
export { ForwardRef as ReactComponent };